<template>
    <b-button
        v-b-tooltip.hover
        size="lg"
        variant="icon"
        :title="$translate('tutorials')"
        @click="showTutorialForCurrentView"
    >
        <video-icon />
    </b-button>
</template>

<script>
import { mapGetters } from 'vuex'
import UIUtils from '../../../business/utils/UIUtils'
import VideoIcon from './icons/VideoIcon'

export default {
    name: 'TutorialButton',
    components: { VideoIcon },
    computed: {
        ...mapGetters({
            tutorialForCurrentView: 'onboarding/tutorialForCurrentView'
        })
    },
    methods: {
        showTutorialForCurrentView() {
            this.$log.actionEvent('show_tutorial_for_view')

            if (this.tutorialForCurrentView) {
                UIUtils.showModal('video_tutorial', data => {
                    data.componentTutorial = this.tutorialForCurrentView(this.$route)
                })
            }
        }
    }
}
</script>
